//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import onScroll from '~/directives/scroll'

export default {
  name: 'Homepage',

  directives: {
    scroll: onScroll
  },

  data() {
    return {
      showButton: false
    }
  },

  computed: {
    ...mapGetters('user', ['isLoggedIn'])
  },

  methods: {
    handleScroll() {
      const topBounds =
        document.getElementById('sentinel').getBoundingClientRect().top < 0
      const bottomBounds =
        document.getElementById('content').getBoundingClientRect().bottom >
        window.innerHeight
      this.showButton = Boolean(topBounds && bottomBounds)
    }
  },

  head() {
    return {
      link: [
        {
          rel: 'preload',
          as: 'image',
          href: 'https://cdn.humnutrition.com/assets/homepage/slider/good-science/mobile-background.jpg',
          imagesrcset:
            'https://cdn.humnutrition.com/assets/homepage/slider/good-science/mobile-background.jpg 1x, https://cdn.humnutrition.com/assets/homepage/slider/good-science/mobile-background@2x.jpg 2x',
          media: '(max-width: 767px)'
        },
        {
          rel: 'preload',
          as: 'image',
          href: 'https://cdn.humnutrition.com/assets/homepage/slider/good-science/desktop-background.jpg',
          imagesrcset:
            'https://cdn.humnutrition.com/assets/homepage/slider/good-science/desktop-background.jpg 1x, https://cdn.humnutrition.com/assets/homepage/slider/good-science/desktop-background@2x.jpg 2x',
          media: '(min-width: 768px)'
        }
      ],
      script: [
        {
          innerHTML: `amplitude.getInstance().logEvent('viewedHomepage', { landingPageSource: getUtmSource() })`
        }
      ]
    }
  }
}
